import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

@Injectable({ providedIn: 'root' })
export class SuperAdminGuard implements CanActivate {

  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  canActivate(): boolean {
    const session = this.sessionService.getSession();

    if (session && session.role === 'SuperAdmin') {
      return true;
    }

    // Not a SuperAdmin — send to login
    this.router.navigate(['/auth/login']);
    return false;
  }
}